import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';

// Funzione per creare e restituire il PDF come Blob pronto per il download
export async function createLetter(data, clienti) {
  const pdfDoc = await PDFDocument.create();
  const page = pdfDoc.addPage([612, 792]); // formato letter
  const { width, height } = page.getSize();
// registra fontkit prima di embedFont
pdfDoc.registerFontkit(fontkit);

const fontNormalBytes = await fetch('/fonts/Poppins-Regular.ttf').then(res => res.arrayBuffer());
const fontBoldBytes = await fetch('/fonts/Poppins-Bold.ttf').then(res => res.arrayBuffer());

const fontNormal = await pdfDoc.embedFont(fontNormalBytes);
const fontBold = await pdfDoc.embedFont(fontBoldBytes);
  // Margini e coordinate iniziali
  let y = height - 60;
  const marginLeft = 50;
  const lineHeight = 16;

  // --- LOGO ---
  const logoUrl = 'logo.png';
  const logoBytes = await fetch(logoUrl).then(res => res.arrayBuffer());
  const logoImage = await pdfDoc.embedPng(logoBytes);
  const logoWidth = 100;
  const logoHeight = 100;
  page.drawImage(logoImage, {
    x: marginLeft,
    y: y - logoHeight,
    width: logoWidth,
    height: logoHeight,
  });

  // --- DATA ---
  y -= 130;

  // --- INTESTAZIONE CONTATTI ---
  const contactLines = [
    "Jacopo Cantini",
    "P.O. Box 320 Watamu, Kenya",
    "Phone number: +254715905550",
    "Email: hello@jckiteschool.com",
  ];
  for (const line of contactLines) {
    page.drawText(line, { x: marginLeft, y, size: 10, font: fontBold });
    y -= lineHeight;
  }

  y -= 20;

  // --- TITOLO ---
  const title = "Booking Confirmation";
  const titleWidth = fontBold.widthOfTextAtSize(title, 14);
  page.drawText(title, {
    x: (width - titleWidth) / 2,
    y,
    size: 14,
    font: fontBold,
  });

  y -= 30;

  // --- DATE ---
  page.drawText("Booking dates:", { x: marginLeft, y, size: 10, font: fontNormal });
  y -= lineHeight;
  const dateLine = `From ${data[0]["Check-In"]} (arrival date) to ${data[0]["Check-Out"]} (departure date).`;
  page.drawText(dateLine, { x: marginLeft + 20, y, size: 10, font: fontNormal });

  y -= 25;

  // --- CLIENTI ---
  page.drawText("Customers:", { x: marginLeft, y, size: 10, font: fontNormal });
  y -= lineHeight;

  for (const c of clienti) {
    const text = `- ${c.Nome} ${c.Cognome}, passport number: ${c["Numero di documento"]}`;
    page.drawText(text, { x: marginLeft + 20, y, size: 10, font: fontNormal });
    y -= lineHeight;
  }

  y -= 25;

  // --- ALLOGGIO ---
  page.drawText("Accommodation:", { x: marginLeft, y, size: 10, font: fontNormal });
  y -= lineHeight;

  const num = Math.floor(clienti.length / 3);
  let text;
  if (clienti.length > 3 && clienti.length % 3 !== 0) {
    text = `${num} large Triple Bedroom and 1 double Bedroom at Watamu Beach Cottages, Turtle Bay Road, 80202, Kenya.`;
  } else if (clienti.length === 3 || clienti.length % 3 === 0) {
    text = `${num} large Triple Bedroom at Watamu Beach Cottages, Turtle Bay Road, 80202, Kenya.`;
  } else {
    text = `1 double Bedroom at Watamu Beach Cottages, Turtle Bay Road, 80202, Kenya.`;
  }
  page.drawText(text, { x: marginLeft + 20, y, size: 10, font: fontNormal });

  y -= 40;

  // --- FIRMA E DETTAGLI FINALI ---
  page.drawText("JACOPO CANTINI", { x: marginLeft, y, size: 10, font: fontNormal });
  page.drawText("FOUNDER AND CEO OF JC KITE HOUSE SCHOOL", { x: marginLeft, y: y - 15, size: 10, font: fontNormal });

  // Firma
  const firmaUrl = 'firma.png';
  const firmaBytes = await fetch(firmaUrl).then(res => res.arrayBuffer());
  const firmaImage = await pdfDoc.embedPng(firmaBytes);
  page.drawImage(firmaImage, {
    x: width - 350,
    y: y - 120,
    width: 300,
    height: 100,
  });

  // Salva e restituisci Blob
  const pdfBytes = await pdfDoc.save();
  return new Blob([pdfBytes], { type: "application/pdf" });
}
